import { BigNumber, ethers } from 'ethers'
import { useWeb3React } from '@web3-react/core'
import { MutatorOptions, useSWRConfig } from 'swr'

import { CacheKey } from 'web/lib/cache-keys'
import usePolygonForwarder from './usePolygonForwarder'
import useBloodBalance from './useBloodBalance'
import { PolygonAddresses } from 'web/lib/contract'

export default function useBloodToken() {
  const { account } = useWeb3React()
  const { mutate } = useSWRConfig()
  const { polygonForwarderSubmit } = usePolygonForwarder()
  const balance = useBloodBalance()

  const updateBloodBalance = async (optimisticBalance: number = 0): Promise<void> => {
    // console.log("updateBloodBalance...")
    const options: MutatorOptions = {
      optimisticData: optimisticBalance,
      rollbackOnError: true
    }
    return mutate(CacheKey.bloodBalance(account), optimisticBalance, options)
  }

  const updateBloodAllowance = async (contractAddr: string): Promise<void> => {
    return mutate(CacheKey.bloodAllowance(account, contractAddr))
  }

  // Maybe move to useBloodAllowance?
  const handleApproval = async (contractAddr = PolygonAddresses.BloodShop): Promise<void> => {
    const amount = ethers.constants.MaxUint256
    console.log(`handleApproval() contractAddr=${contractAddr} amount=${amount}`)

    return polygonForwarderSubmit('Blood', 'approve', [contractAddr, amount]).then((receipt) => {
      updateBloodAllowance(contractAddr)
    })
  }

  const handleTransfer = async (from: string, to: string, amount: string): Promise<void> => {
    const etherAmount = ethers.utils.parseEther(amount)
    console.log(`handleTransfer() from=${from} to=${to} amount=${amount} etherAmount=${etherAmount.toString()}`)

    return polygonForwarderSubmit('Blood', 'transfer', [to, etherAmount]).then((receipt) => {
      updateBloodBalance(balance)
    })
  }

  // TODO move to its own hook
  const addTokenToMetamask = async (type, address, symbol, decimals, image): Promise<void> => {
    console.log("addTokenToMetamask", { type, address, symbol, decimals, image })
    try {
      // @ts-ignore
      const wasAdded = await ethereum.request({
        method: 'wallet_watchAsset',
        params: {
          type: type,
          options: {
            address: address,
            symbol: symbol,
            decimals: decimals,
            image: image,
          },
        },
      })

      if (wasAdded) {
        console.log(`Added ${type} token ${symbol} successfully`)
      } else {
        console.log(`Failed to add token`, { type, address, symbol, decimals, image })
      }
    } catch (e) {
      console.log('addTokenToMetamask error:', e)
    }
  }

  const addBloodTokenToMetamask = async(): Promise<void> => {
    return addTokenToMetamask('ERC20', PolygonAddresses.Blood, 'BLOOD', 18, 'https://www.gawds.xyz/images/flame.png')
  }

  return {
    handleApproval,
    handleTransfer,
    updateBloodAllowance,
    updateBloodBalance,
    addTokenToMetamask,
    addBloodTokenToMetamask
  }
}